// The version of the app — web/package.json's, the same as the server's (tests/version.xq) — which
// build.mjs puts into the code.
declare const __APP_VERSION__: string;

/** The version of Veyumo. */
export const VERSION: string = __APP_VERSION__;
